import { render, staticRenderFns } from "./TestTypesReorder.vue?vue&type=template&id=649df8a2&scoped=true&"
import script from "./TestTypesReorder.vue?vue&type=script&lang=js&"
export * from "./TestTypesReorder.vue?vue&type=script&lang=js&"
import style0 from "./TestTypesReorder.vue?vue&type=style&index=0&id=649df8a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649df8a2",
  null
  
)

export default component.exports